import { Component, Input, OnInit } from '@angular/core';
import { BarGraph, NewBarGraph } from '@app/interfaces/IGraphStyle';

@Component({
  selector: 'app-vertical-stacked-bar-chart',
  templateUrl: './vertical-stacked-bar-chart.component.html',
  styleUrls: ['./vertical-stacked-bar-chart.component.scss']
})
export class VerticalStackedBarChartComponent {
  /**
  * all the styling and data input are mentioned here.
  */
  @Input() breakPointclass: any;
  @Input() styles: NewBarGraph;
  @Input() data: any;
  animations: boolean;
  showXAxis: any;
  legendPosition: any;

  publicSingle: any[] | undefined;
  publicMulti: any[] | undefined;
  name = 'Angular';
  fitContainer: boolean = true;
  colorScheme: any = {
    domain: ['#F0B323', '#54AD40', '#F51B2C']
  };
  showLabels = true;
}
